/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo } from "react";
import { useSelector } from "react-redux";
import store from "../../store";
import { removeActiveThreadChat } from "../redux/chatSlice";
import { XIcon } from "../../assets/icons/svg";

const ThreadBoardHeader = () => {
  const { chatRoom } = useSelector((state) => state.chat);

  const handleRemoveActiveThreadChat = (value) => {
    store.dispatch(removeActiveThreadChat(value));
  };

  return (
    <>
      <div className="head px-3">
        <div className="name">Thread</div>

        <div
          className="cursor-pointer "
          onClick={() => handleRemoveActiveThreadChat(chatRoom)}
        >
          <XIcon />
        </div>
      </div>
    </>
  );
};

export default memo(ThreadBoardHeader);
